export default "__VITE_ASSET__cd197d8e__"